export default function (theme) {
    return {
        MuiTabs: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.background.paper
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                wrapper: {  // style seems to have been removed in v5
                    textTransform: 'none',
                    fontSize: 14,
                    '@media(max-width:320px)': {
                        fontSize: 13
                    }
                },
                textColorPrimary: {
                    color: theme.palette.text.primary,
                    fontWeight: 600,
                    '&.Mui-selected': {
                        color: theme.palette.primary.main,
                    },
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.light,
                    }
                }
            }
        }
    };
}